import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Badge } from '@material-ui/core';

import { APPROVAL_TYPE, getApprovalTypeTitle } from 'src/data/brandTerm';
import { useStyles } from './useStyles';

export const ApprovalTypeBadge = ({ className, approvalType }) => {
  const styles = useStyles();

  return (
    <Badge
      className={cx(styles.root, className, {
        [styles.approved]: approvalType === APPROVAL_TYPE.approved,
        [styles.doNotUse]: approvalType === APPROVAL_TYPE.doNotUse,
      })}
    >
      {getApprovalTypeTitle(approvalType)}
    </Badge>
  );
};

ApprovalTypeBadge.propTypes = {
  className: PropTypes.string,
  approvalType: PropTypes.oneOf(Object.values(APPROVAL_TYPE)).isRequired,
};

ApprovalTypeBadge.defaultProps = {
  className: '',
};
